import React from 'react';

import './style.scss';

function FooterComponent() {
  return (
    <footer>
      <hr />
      <h5 className="Footer-Text d-flex justify-content-end mr-5">
        Copyright © Designed and Made by David Félix
      </h5>
    </footer>
  );
}

export default FooterComponent;
